<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import axios from "axios";

import {
  required,
  //email,
  //minLength,
  //sameAs,
  //maxLength,
  //minValue,
  //maxValue,
  //numeric,
  //url,
  //alphaNum
} from "vuelidate/lib/validators";

/**
 * Form validation component
 */
export default {
  page: {
    title: "Model",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, /*Basic*/ },
  props:{
    id:[Number,null],
  },
  data() {
    return {
      info: null,
      title: "Model registration",
      componentKey: 0,
      items: [
        {
          text: "Equipment",
          href: "/"
        },
        {
          text: "Models",
          href: "/equipment/models"
        },
        {
          text: "Model",
          active: true
        }
      ],
      brands: [],
      models: [],
      form: {
        id_brand: "",
        nm_model: "",
        de_description: "",
      },
      submitted: false,
    };
  },
  validations: {
    form: {
      id_brand:       { required },
      nm_model:       { required},
    }
  },
  watch:{
    
  },
  created(){
    this.getBrands();

    if( this.$route.params.id ){
      this.getModelByID(this.$route.params.id);
    }
  },
  mounted() {
    
  },
  methods: {
    getBrands(){
      let app = this;

      axios
      .get(
        window.serverPath+'dist/mvw/controllers/brands.php',
        {
          params: {
            request: 'getBrands',
          }
        }
      )
      .then(response => {
        
        Swal.close();
        if( response.statusText == "OK" ){
          if(response.data){
            app.brands  = response.data
          }else{
            Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
          }
        }else{
          Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
        }
      })
      .catch(function (error) {
        
        app.isLoading = false;
        if(
          error.code == "ERR_BAD_RESPONSE"    ||
          error.code == "ERR_NETWORK"
        ){
          Swal.fire('Ooops!!!','<p><b>Something wrong with the communication between your computer and our server.<br>Please check your internet connection.</b></p>','error');
        }
      });
    },

    getModelByID(idModel){
      let app = this;

      Swal.fire({
        title: 'Getting product data.',
        showConfirmButton:false,
      });

      axios
      .get(
        window.serverPath+'dist/mvw/controllers/models.php',
        {
          params: {
            request: 'getModelByID',
            id: idModel
          }
        }
      )
      .then(response => {
        Swal.close();
        if( response.statusText == "OK" ){
          if(response.data){
            app.form.id_brand       = response.data.id_brand;
            app.form.id_model       = response.data.id_model;
            app.form.nm_model       = response.data.nm_model;
            app.form.de_description = response.data.de_description;
          }else{
            Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
          }
        }else{
          Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
        }
      })
      .catch(function (error) {
        
        app.isLoading = false;
        if(
          error.code == "ERR_BAD_RESPONSE"    ||
          error.code == "ERR_NETWORK"
        ){
          Swal.fire('Ooops!!!','<p><b>Something wrong with the communication between your computer and our server.<br>Please check your internet connection.</b></p>','error');
        }
      });
    },


    // eslint-disable-next-line no-unused-vars
    saveModel(e) {
      let app = this;

      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();
      
      if( !this.$v.form.$error ){
        if( this.$route.params.id ){
          this.form.id_model = this.$route.params.id;
        }

        Swal.fire({
          title: "Saving model.",
          showConfirmButton:false,
          onBeforeOpen: () => {
            Swal.showLoading();
          }
        });

        axios.post(window.serverPath+'dist/mvw/controllers/models.php', {
          request: 'saveModel',
          data: this.form, 
        })
        .then(function (response) {
          let action = "";
          if( response.data === "OK" ){
            action = "saved";
          }
          if( response.data === "UPDATED" ){
            action = "updated";
          }

          Swal.fire("Good job!", "Your model is correct "+action+"!", "success");
          app.$router.push({ name: 'models' });
        })
        .catch(function (error) {
          Swal.fire("Ooops!" + error.message, "Seems like some error ocurr, please try again.", "error");
        });
      }
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />


    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <form class="needs-validation" @submit.prevent="saveModel">
              <div class="row">
                <div class="col-lg-12">
                  <h4 class="card-title">Model Information</h4>
                  <p class="card-title-desc">Provide all information related to the equipment model.</p>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="id_brand">Brand</label>
                        <select
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.id_brand.$error }"
                          name="id_brand"
                          id="id_brand"
                          v-model="form.id_brand"
                        >
                          <option value="">SELECT YOUR BRAND</option>
                          <option v-for="(brand, index) in brands" :key="index" :value="brand.id_brand">{{brand.nm_brand}}</option>
                        </select>
                        <div v-if="submitted && $v.form.id_brand.$error" class="invalid-feedback">
                          <span v-if="!$v.form.id_brand.required">Brand field is required.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="nm_model">Model name</label>
                        <input
                          type="text"
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.nm_model.$error }"
                          name="nm_model"
                          id="nm_model"
                          v-model="form.nm_model"
                          value=""
                        >
                        <div v-if="submitted && $v.form.nm_model.$error" class="invalid-feedback">
                          <span v-if="!$v.form.nm_model.required">Model name is required.</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!--
                <div class="col-lg-8">
                  <h4 class="card-title">Model General Description</h4>
                  <p class="card-title-desc">Provide the description table for your model.</p>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="de_description">Description</label>
                        <div class="form-group">
                          <ckeditor type="classic" name="de_description" v-model="form.de_description" :class="{ 'is-invalid': submitted && $v.form.de_description.$error }"></ckeditor>
                          <div v-if="submitted && $v.form.de_description.$error" class="invalid-feedback">
                            <span v-if="!$v.form.de_description.required">Model description is required.</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                -->

                <!--
                <div class="col-lg-4"> 
                </div>
                -->
              </div>

              <div class="row">
                <div class="col-lg-12 mt-5 pt-5">
                  <div class="form-group text-center">
                    <button class="btn btn-success" type="submit">SAVE MODEL</button>
                    <router-link to="/equipment/models" class="ml-3">
                      <button class="btn btn-danger" type="reset">CANCEL </button>
                    </router-link>
                  </div>
                </div>
              </div>
          </form>
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>